import React from "react";

const AppML_Case_Customers = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Customers</h1>
      <p>This is the AppML Case Customers page content.</p>
    </div>
  );
};

export default AppML_Case_Customers;
